var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.getParams
        ? _c(
            "v-menu",
            {
              staticClass: "v-menu",
              attrs: {
                left: "",
                origin: "center center",
                transition: "scale-transition",
                "data-testid":
                  (_vm.params.testId ? _vm.params.testId + "__" : "") +
                  "MenuItem"
              }
            },
            [
              _c(
                "v-btn",
                { attrs: { slot: "activator", icon: "" }, slot: "activator" },
                [
                  _c("v-icon", { attrs: { color: "#526da5" } }, [
                    _vm._v("more_vert")
                  ])
                ],
                1
              ),
              _c(
                "v-list",
                [
                  _vm.getParams
                    ? _c(
                        "v-list-tile",
                        { staticStyle: { height: "40px" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            { staticStyle: { "min-width": "35px" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { small: "", icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleItemClick(
                                        _vm.Accion.Editar
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", color: "#526da5" } },
                                    [_vm._v("edit")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-list-tile-title",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                "font-size": "13px",
                                color: "rgba(0,0,0,0.7)"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleItemClick(_vm.Accion.Editar)
                                }
                              }
                            },
                            [_vm._v("Editar")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.getParams
                    ? _c(
                        "v-list-tile",
                        { staticStyle: { height: "40px" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            { staticStyle: { "min-width": "35px" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { small: "", icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleItemClick(
                                        _vm.Accion.Eliminar
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", color: "#526da5" } },
                                    [_vm._v("delete")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-list-tile-title",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                "font-size": "13px",
                                color: "rgba(0,0,0,0.7)"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleItemClick(
                                    _vm.Accion.Eliminar
                                  )
                                }
                              }
                            },
                            [_vm._v("Eliminar")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.params.typeModal == "cotizacion"
        ? _c(
            "v-menu",
            {
              staticClass: "v-menu",
              attrs: {
                left: "",
                origin: "center center",
                transition: "scale-transition",
                "data-testid":
                  (_vm.params.testId ? _vm.params.testId + "__" : "") +
                  "MenuItem"
              }
            },
            [
              _c(
                "v-btn",
                { attrs: { slot: "activator", icon: "" }, slot: "activator" },
                [
                  _c("v-icon", { attrs: { color: "#526da5" } }, [
                    _vm._v("more_vert")
                  ])
                ],
                1
              ),
              _c(
                "v-list",
                [
                  _vm.params.typeModal == "cotizacion" &&
                  (_vm.params.data.estado == "ENVIADA" ||
                    _vm.params.data.estado == "POR ENVIAR")
                    ? _c(
                        "v-list-tile",
                        { staticStyle: { height: "40px" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            { staticStyle: { "min-width": "35px" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { small: "", icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleItemClick_2(
                                        _vm.Accion.VerPdf
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", color: "#526da5" } },
                                    [_vm._v(_vm._s(_vm.btnVerIcon))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-list-tile-title",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                "font-size": "13px",
                                color: "rgba(0,0,0,0.7)"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleItemClick_2(
                                    _vm.Accion.VerPdf
                                  )
                                }
                              }
                            },
                            [_vm._v("Ver PDF")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.params.typeModal == "cotizacion" &&
                  _vm.params.data.estado == "PENDIENTE"
                    ? _c(
                        "v-list-tile",
                        { staticStyle: { height: "40px" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            { staticStyle: { "min-width": "35px" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { small: "", icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleItemClick_2(
                                        _vm.Accion.Editar
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", color: "#526da5" } },
                                    [_vm._v("edit")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-list-tile-title",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                "font-size": "13px",
                                color: "rgba(0,0,0,0.7)"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleItemClick_2(
                                    _vm.Accion.Editar
                                  )
                                }
                              }
                            },
                            [_vm._v("Editar")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.params.typeModal == "cotizacion" &&
                  _vm.params.data.estado == "ENVIADA"
                    ? _c(
                        "v-list-tile",
                        { staticStyle: { height: "40px" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            { staticStyle: { "min-width": "35px" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { small: "", icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleItemClick_2(
                                        _vm.Accion.Enviar
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", color: "#526da5" } },
                                    [_vm._v("email")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-list-tile-title",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                "font-size": "13px",
                                color: "rgba(0,0,0,0.7)"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleItemClick_2(
                                    _vm.Accion.Enviar
                                  )
                                }
                              }
                            },
                            [_vm._v("Reenviar cotización")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }